import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Alert, Badge } from "components/bootstrap";
import { Spinner } from "components/common";
import useWorkflowRequiredPermissions from "aiagent/AgentWorkflows/hooks/useWorkflowRequiredPermissions";
const PermissionList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacings.xxs};
  `
);
const WorkflowRequiredPermissions = ({ workflowId }) => {
  const { t } = useTranslation("enterprise_ai");
  const { data: permissions, isLoading, isError, error } = useWorkflowRequiredPermissions(workflowId);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: t("workflow_required_permissions.loading") });
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: t("workflow_required_permissions.load_failed") }, error instanceof Error ? error.message : t("common_texts.unknown_error"));
  }
  if (!(permissions == null ? void 0 : permissions.length)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, t("workflow_required_permissions.none"));
  }
  return /* @__PURE__ */ React.createElement(PermissionList, null, permissions.map((permission) => /* @__PURE__ */ React.createElement(Badge, { bsStyle: "default", key: permission }, permission)));
};
export default WorkflowRequiredPermissions;
